import { useState, useEffect } from 'react';

export const useHasScrolled = (threshold = 76, delay = 15) => {
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    let timeoutId;

    const handleScroll = () => {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        setHasScrolled(window.scrollY > threshold);
      }, delay);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timeoutId);
    };
  }, [threshold, delay]);

  return hasScrolled;
};
